/**
 * Static text content for grid renderers.
 * You can add more renderer types as needed.
 * This will automatically be used to translate when translating grid renderers.
 */
export const GRID_RENDERERS_STATIC_TEXT_CONTENT = {};
